"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { FUSportsMatchEvent } from "fansunited-data-layer";
import { getEventTypeLabel, type EventLabels } from "./matchEventHelpers";
import { PlayerLink } from "./PlayerLink";
interface GenericEventCardProps {
  event: FUSportsMatchEvent;
  eventLabels: EventLabels;
}

/**
 * GenericEventCard - Displays a generic event (for event types without specific styling)
 */
export const GenericEventCard: React.FC<GenericEventCardProps> = t0 => {
  const $ = _c(11);
  const {
    event,
    eventLabels
  } = t0;
  let t1;
  if ($[0] !== event.type || $[1] !== eventLabels) {
    t1 = getEventTypeLabel(event.type, eventLabels);
    $[0] = event.type;
    $[1] = eventLabels;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const typeLabel = t1;
  const player = event.primaryPlayer;
  let t2;
  if ($[3] !== typeLabel) {
    t2 = <div className="flex items-center gap-1.5 mb-1.5"><span className="text-xs font-semibold text-muted-foreground uppercase">{typeLabel}</span></div>;
    $[3] = typeLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = player?.id;
  const t4 = player?.name || "Unknown";
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <PlayerLink playerId={t3} className="text-sm font-semibold text-foreground">{t4}</PlayerLink>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <div className="bg-muted border border-border rounded-lg p-3 shadow-sm min-w-0 w-48 md:w-72">{t2}{t5}</div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};